import { render, staticRenderFns } from "./TravelTimeList.vue?vue&type=template&id=b652fe9c&scoped=true"
import script from "./TravelTimeList.vue?vue&type=script&lang=ts"
export * from "./TravelTimeList.vue?vue&type=script&lang=ts"
import style0 from "./TravelTimeList.vue?vue&type=style&index=0&id=b652fe9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b652fe9c",
  null
  
)

export default component.exports